import { addElementToConditionAction, addElementToConditionGroupAction } from 'editor/src/store/design/slice';
import { MediaElement, SlotLayout } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

/**
 * Lists a frame's layer under its product's picklist, or as a plain personalisation field when
 * the layout has no per-product choice. A locked layer with nothing to list under stays out of
 * the tree, as any decoration does.
 */
function attachSlotElementToProduct(
  dispatch: ThunkDispatch,
  getState: () => RootState,
  spreadIndex: number,
  layout: Pick<SlotLayout, 'productConditionIds'>,
  product: number,
  element: MediaElement,
  optionIndexes?: number[],
) {
  const conditionId = layout.productConditionIds[product - 1];
  const condition = conditionId
    ? getState().design.designData?.spreads[spreadIndex]?.conditionGroup?.conditions[conditionId]
    : undefined;
  if (!condition) {
    if (!element.personalizationLocked) {
      dispatch(addElementToConditionGroupAction({ spreadIndex, element }));
    }
    return;
  }
  const indexes = optionIndexes ?? condition.options.map((_, index) => index);
  indexes.forEach((index) => {
    const option = condition.options[index];
    if (option) {
      dispatch(addElementToConditionAction({ address: { spreadIndex, conditionId }, optionId: option.id, element }));
    }
  });
}

export default attachSlotElementToProduct;
